import { storeStructure } from '../store/reducers';
import tableIngestServer from './tableIngestServer';

export default {
  title: 'Ingest servers',
  attributeName: 'ingestservers',
  getURL: 'ingestserver',
  // updateURL: 'liveStatus',
  removeURL: 'ingestserver',
  sessionParams: [],
  noArea: true,
  tableConfig: tableIngestServer,
  // sessionWebsocketParams: [],
  autoUpdate: true,
  // websocketNavigation:'users_navigation',
};
